<template>
  <div class="w-100">
    <p
      v-if="!myPending.length"
      class="w-100 text-body-1 text-textDarkest text-center mt-8"
    >
      You're all caught up!
    </p>
    <ul v-else class="approval-list">
      <li
        v-for="item in myPending"
        :key="item.ulid"
        class="approval-item"
      >
        <div class="left-side">
          <p class="text-body-1 text-textLight">
            <span class="text-h3 text-textDarkest">
              {{ formatRequesterName(item.created_by) }}
            </span> requested your approval of
            <span class="text-h3 text-textDarkest">
              {{ item.draft_profile?.title }}
            </span>
          </p>
          <p class="text-body-1 text-textLight">
            {{ format(item.created_at, 'PPP') }}
          </p>
        </div>
        <div class="right-side">
          <button
            type="button"
            class="view-approval"
          >
            <router-link
              :to="{ name: 'approval-actions', params: { id: item.ulid } }"
              class="text-button-3 text-textDarkest"
            >
              View
            </router-link>
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { format } from 'date-fns';
import { formatUserDisplayName } from '@/helpers/user';
import { useApprovalFlows } from '@/stores/jobProfiles/approvalFlows';

const { myPending } = storeToRefs(useApprovalFlows());

const formatRequesterName = (createdBy) => {
  if (createdBy?.first_name || createdBy?.last_name) {
    return `${createdBy.first_name} ${createdBy.last_name?.[0]}`;
  }

  return formatUserDisplayName(createdBy) || 'A team member';
};
</script>

<style lang="less" scoped>
.approval-list {
  width: 100%;
}

.approval-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 16px;

  .right-side {
    display: none;
  }

  &:hover {
    background-color: @bg-canvas;

    .right-side {
      display: block;
    }
  }
}

.view-approval {
  border: 1px solid @stroke-default;
  border-radius: 8px;
  background-color: @bg-default;

  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px 15px;
  }

  &:hover {
    background-color: @bg-dark;
  }
}
</style>
